import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppMessageService } from '../../../services/message.service';
import { SpinnerService } from '../../../components/spinner/spinner.service';
import { Customer } from '../../../entities/customer.entity';
import { ApiService } from '../../../services/api.service';
import { DbFile } from '@entities/db-file.entity';

@Component({
	selector: 'app-new-customer-dialog',
	template: `
		<div class="flex items-center mb-1" mat-dialog-title style="margin-bottom:15px">
			<p class="flex-auto text-lg font-medium">
				{{ 'CUSTOMER.NEW_CUSTOMER.HEADLINE' | translate }}
			</p>
			<button mat-dialog-close mat-icon-button type="button">
				<mat-icon size="24px">close</mat-icon>
			</button>
		</div>

		<mat-dialog-content>

			<mat-form-field appearance="outline" class="block w-full">
				<mat-label>Name</mat-label>
				<input matInput type="text" [(ngModel)]="customer.name"/>
			</mat-form-field>

			<div>
				<button type="button" mat-raised-button (click)="fileInput.click()">
					{{ 'CUSTOMER.NEW_CUSTOMER.CHOOSE_IMAGE' | translate }}
				</button>
				<input hidden (change)="onFileSelected()" #fileInput type="file" id="file" />
				<span class="p-4">{{ fileName }}</span>
			</div>
			<br />

		</mat-dialog-content>

		<mat-dialog-actions>
			<span class="flex-1"></span>
			<button [disabled]="!customer.name" (click)="save()" color="primary" mat-flat-button type="button">
				<span>{{ 'BUTTON.SAVE' | translate }}</span>
				<!--<ic-icon [icIcon]="icSend" [inline]="true" class="ml-2" size="16px"></ic-icon>-->
			</button>
		</mat-dialog-actions>
	`,
	styleUrls: [],
	animations: [],
	encapsulation: ViewEncapsulation.None
})
export class NewCustomerDialogComponent implements OnInit {
	customer: Customer;
	fileName;
	constructor(
		private dialogRef: MatDialogRef<NewCustomerDialogComponent>,
		private apiService: ApiService,
		private spinner: SpinnerService,
		private appMessageService: AppMessageService,
	) {
	}

	ngOnInit(): void {
		 this.customer = {
		 	name: '',
		 	dbFile: DbFile
		 } as Customer;
	}

	public onFileSelected() {
		const inputNode: any = document.querySelector('#file');
		if (typeof FileReader !== 'undefined') {
			const reader = new FileReader();
			this.fileName = inputNode.files[0].name;
			reader.onload = (e: any) => {
				this.customer.dbFile = { name: `${Date.now()}_${this.fileName}`, content: e.target.result };
			};
			reader.readAsDataURL(inputNode.files[0]);
		}
	}

	close() {
		this.dialogRef.close();
	}

	async save() {
		console.log('New Customer', this.customer);

		try {
			await this.apiService.post("customers", this.customer);
			this.appMessageService.showToastSuccess('Stored customer');
			this.close();
		} catch (e) {
			console.error(e);
		}
	}

}
